"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var EnoLined = function EnoLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.285 15.59a.5.5 0 01.127.694A4.32 4.32 0 0111.989 18a4.256 4.256 0 01-3.4-1.721.5.5 0 01.829-.56A3.236 3.236 0 0011.989 17a3.3 3.3 0 002.6-1.286.5.5 0 01.696-.124zM21 11.969c0 3.229-.663 5.72-1.97 7.4A7.29 7.29 0 0113 22h-2a8.243 8.243 0 01-3.855-.958.489.489 0 00-.3-.058l-2.76.628h-.063a1.094 1.094 0 01-.717-.36.962.962 0 01-.279-.909l.828-2.7a.474.474 0 00-.017-.316A15.113 15.113 0 013 11.969c0-3.229.663-5.72 1.97-7.4A7.193 7.193 0 0111 2h2a7.193 7.193 0 016.03 2.564C20.337 6.249 21 8.74 21 11.969zm-1 0c0-3-.592-5.286-1.76-6.792A6.248 6.248 0 0013 3h-2a6.248 6.248 0 00-5.24 2.177C4.592 6.683 4 8.967 4 11.969a14.1 14.1 0 00.771 5 1.475 1.475 0 01.04.967l-.821 2.672L6.667 20a1.833 1.833 0 01.241-.017 1.48 1.48 0 01.7.172A7.25 7.25 0 0011 21h2a6.249 6.249 0 005.24-2.24c1.168-1.505 1.76-3.79 1.76-6.791z",
    fill: "currentColor"
  })));
};

var _default = EnoLined;
exports["default"] = _default;